// Contract of GET/PUT v1/integrations/salesforce.
export const SALESFORCE_SLUG = 'salesforce';

// The backend never returns credentials: when they are set they come back as this mask.
export const SALESFORCE_MASKED_VALUE = '***';

export const SALESFORCE_PLAIN_KEYS = [
  'eventsBaseUrl',
  'mcAuthUrl',
  'mcRestUrl',
  'mcUsersDataExtensionKey',
  'mcClientId',
] as const;

export const SALESFORCE_SECRET_KEYS = ['eventsApiKey', 'eventsApiSecret', 'mcClientSecret'] as const;

export const SALESFORCE_HTTPS_URL_KEYS: ReadonlyArray<SalesforcePlainKey> = ['eventsBaseUrl', 'mcAuthUrl', 'mcRestUrl'];

// No env var to fall back to: cannot be cleared once set, nor missing to switch it on (as the backend).
export const SALESFORCE_REQUIRED_KEYS: ReadonlyArray<SalesforcePlainKey> = ['eventsBaseUrl'];

export type SalesforcePlainKey = (typeof SALESFORCE_PLAIN_KEYS)[number];
export type SalesforceSecretKey = (typeof SALESFORCE_SECRET_KEYS)[number];
export type SalesforceKey = SalesforcePlainKey | SalesforceSecretKey;

// Value still read from a server env var (seeded on deploy until an admin replaces it).
export interface SecretRef {
  $secretRef: string;
}

export type SalesforceStoredValue = string | SecretRef | null;

export interface SalesforceIntegrationResponse {
  slug: string;
  enabled: boolean;
  settings: Partial<Record<SalesforceKey, SalesforceStoredValue>>;
  computed?: {
    eventsCredentialsConfigured: boolean;
    mcCredentialsConfigured: boolean;
  };
  updatedAt: string;
}

export const isSecretRef = (value: unknown): value is SecretRef =>
  !!value && typeof value === 'object' && typeof (value as SecretRef).$secretRef === 'string';
